module.exports = __webpack_public_path__ + "img/csv-upload.35517094.jpg";